import axios from "axios";

const configuredApiBase = process.env.REACT_APP_NOT_SECRET_CODE || "";
const apiBase = configuredApiBase.replace(/\/v1\/?$/, "");

const headers = (token) => ({
  "Content-Type": "application/json",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: "Bearer " + token,
});

const unwrapApiResponse = (res) => {
  const payload = res.data;

  if (payload && payload.success === false) {
    const error = new Error(payload.message || "Request failed.");
    error.response = { data: payload };
    throw error;
  }

  return payload;
};

export const getOperationsLoadingDashboard = (token, filters = {}) => {
  return axios
    .get(`${apiBase}/v2/operations/loading-dashboard`, {
      params: filters,
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const markOperationsItemsOrdered = (token, orderItemIds) => {
  return axios
    .post(
      `${apiBase}/v2/operations/loading-dashboard/items/mark-ordered`,
      { order_item_ids: orderItemIds },
      { headers: headers(token) },
    )
    .then(unwrapApiResponse);
};

export const getOperationsPackingBatch = (token, orderIds) => {
  return axios
    .post(
      `${apiBase}/v2/operations/loading-dashboard/packing-batch`,
      { order_ids: orderIds },
      { headers: headers(token) },
    )
    .then(unwrapApiResponse);
};
